import React, {useState} from 'react';
import {Col, Row} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import RoutList from "./_list";
import RoutForm from "./_form";


export default function Rout(){

    const [collapseForm, setCollapseForm] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const setForm = () => {
        setEditMode(false);
        setCollapseForm(!collapseForm);
        setItem(null);
    }

    const beginEdit = (data) => {
        setEditMode(true);
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !collapseForm &&
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={setForm}/>
                                </div>
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!collapseForm && <RoutList beginEdit={beginEdit}/>}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {collapseForm && <RoutForm setForm={setForm} item={item}/> }
                </Col>
            </Row>
        </div>
    );
}
